<template>
  <section class="mb-12 text-center">
    <a
      v-if="link"
      :href="link"
      target="_blank"
      class="font-weight-light mb-2"
      style="color:#3c4858; font-size:24px"
      v-text="`${heading}`"
    />
    <h1
      v-else
      class="font-weight-light mb-2"
      style="color:#3c4858; font-size:24px"
      v-text="`${heading}`"
    />
    <h2
      class="font-weight-light mb-2"
      style="color:#3c4858; font-size:18px"
      v-text="`${subHeading}`"
    />
  </section>
</template>

<script>
  export default {
    name: 'VComponent',

    props: {
      heading: {
        type: String,
        default: '',
      },
      subHeading: {
        type: String,
        default: '',
      },
      link: {
        type: String,
        default: '',
      },
    },
  }
</script>
